import React from "react";

export default function BuildingWithRupee(props: any) {
  return (
    <svg
      width={204}
      height={164}
      viewBox="0 0 204 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 152H191.693L196.535 154.361L204 158V164H0V152Z"
        fill="#FFAC80"
      />
      <rect
        x={21.3047}
        y={41}
        width={10.9819}
        height={111.068}
        fill="url(#paint0_linear_620_13203)"
      />
      <path
        d="M32.2891 41L69.9983 70.7714V152.068H32.2891V41Z"
        fill="#F9BF8F"
      />
      <rect
        x={39.2969}
        y={61.3125}
        width={3.61496}
        height={90.7586}
        fill="#F17D1E"
      />
      <rect
        x={47.8906}
        y={70.7773}
        width={3.61496}
        height={81.2966}
        fill="#F07C1E"
      />
      <rect
        x={56.4844}
        y={76.9766}
        width={3.61496}
        height={74.8278}
        fill="#F17D1E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.103 121.567L185.005 115.666L190.906 121.567L189.646 122.827L196 129.181L188.833 136.348L186.98 134.494L185.126 136.348L183.148 134.37L181.169 136.348L174.003 129.181L180.36 122.824L179.103 121.567Z"
        fill="url(#paint1_linear_620_13203)"
      />
      <path d="M185 152.374V128.73" stroke="#371083" strokeWidth={1.10455} />
      <rect
        x={76}
        y={130.043}
        width={71.1325}
        height={22.8416}
        fill="#F9BF8F"
      />
      <path
        d="M147.133 122.164H157.286L165.003 129.569V152.887H157.286H147.133V122.164Z"
        fill="#B099E5"
      />
      <path d="M83.1328 139.41H93.286V145.473H83.1328V139.41Z" fill="#F37E1F" />
      <path
        d="M98.1484 139.41H108.302V145.473H98.1484V139.41Z"
        fill="#F37E1F"
      />
      <path d="M115.297 139.41H125.45V145.473H115.297V139.41Z" fill="#F37E1F" />
      <path
        d="M130.172 139.41H140.325V145.473H130.172V139.41Z"
        fill="#F37E1F"
      />
      <path
        d="M87.7811 122H157.476L147.123 130.044H76.0078L87.7811 122Z"
        fill="#C34C13"
      />
      <circle cx={58.5} cy={20.5} r={16.5} fill="#7842DF" />
      <circle cx={142} cy={86} r={12} fill="#7842DF" />
      <circle cx={142} cy={86} r={15.75} stroke="#7842DF" strokeWidth={0.5} />
      <circle
        cx={58.5}
        cy={20.5}
        r={20.25}
        stroke="#7842DF"
        strokeWidth={0.5}
      />
      <path
        d="M146.375 83.375C146.375 83.491 146.329 83.6023 146.247 83.6844C146.165 83.7664 146.054 83.8125 145.938 83.8125H144.179C144.184 83.8847 144.188 83.9574 144.188 84.0313C144.186 84.9012 143.84 85.7352 143.225 86.3503C142.61 86.9655 141.776 87.3115 140.906 87.3125H140.069L144.044 90.9263C144.088 90.9647 144.123 91.0113 144.148 91.0635C144.173 91.1156 144.188 91.1722 144.191 91.23C144.194 91.2878 144.185 91.3457 144.166 91.4002C144.147 91.4548 144.117 91.5049 144.078 91.5478C144.039 91.5906 143.992 91.6253 143.939 91.6498C143.887 91.6744 143.83 91.6882 143.772 91.6906C143.714 91.6931 143.657 91.684 143.602 91.6639C143.548 91.6438 143.498 91.6132 143.456 91.5738L138.643 87.1988C138.578 87.1394 138.532 87.0616 138.512 86.9756C138.491 86.8897 138.498 86.7996 138.529 86.7173C138.561 86.6349 138.617 86.5641 138.69 86.5142C138.763 86.4642 138.849 86.4375 138.938 86.4375H140.906C141.544 86.4368 142.156 86.183 142.607 85.7319C143.058 85.2808 143.312 84.6692 143.312 84.0313C143.312 83.9574 143.309 83.8847 143.302 83.8125H138.938C138.821 83.8125 138.71 83.7664 138.628 83.6844C138.546 83.6023 138.5 83.491 138.5 83.375C138.5 83.259 138.546 83.1477 138.628 83.0656C138.71 82.9836 138.821 82.9375 138.938 82.9375H143.048C142.847 82.5426 142.54 82.2111 142.162 81.9795C141.784 81.7479 141.35 81.6252 140.906 81.625H138.938C138.821 81.625 138.71 81.5789 138.628 81.4969C138.546 81.4148 138.5 81.3035 138.5 81.1875C138.5 81.0715 138.546 80.9602 138.628 80.8781C138.71 80.7961 138.821 80.75 138.938 80.75H145.938C146.054 80.75 146.165 80.7961 146.247 80.8781C146.329 80.9602 146.375 81.0715 146.375 81.1875C146.375 81.3035 146.329 81.4148 146.247 81.4969C146.165 81.5789 146.054 81.625 145.938 81.625H143.134C143.524 81.9861 143.821 82.4365 143.999 82.9375H145.938C146.054 82.9375 146.165 82.9836 146.247 83.0656C146.329 83.1477 146.375 83.259 146.375 83.375Z"
        fill="white"
      />
      <path
        d="M64.25 17.25C64.25 17.4158 64.1842 17.5747 64.0669 17.6919C63.9497 17.8092 63.7908 17.875 63.625 17.875H61.1133C61.1203 17.9781 61.125 18.082 61.125 18.1875C61.1236 19.4303 60.6292 20.6217 59.7505 21.5005C58.8717 22.3792 57.6803 22.8736 56.4375 22.875H55.2414L60.9203 28.0375C60.9822 28.0924 61.0325 28.159 61.0685 28.2335C61.1044 28.308 61.1252 28.3889 61.1296 28.4715C61.1341 28.5541 61.1221 28.6367 61.0944 28.7146C61.0666 28.7925 61.0237 28.8642 60.9681 28.9254C60.9125 28.9866 60.8452 29.0361 60.7703 29.0712C60.6954 29.1062 60.6143 29.126 60.5316 29.1295C60.449 29.1329 60.3665 29.12 60.2889 29.0913C60.2113 29.0626 60.1402 29.0189 60.0797 28.9625L53.2047 22.7125C53.1113 22.6277 53.0459 22.5165 53.0168 22.3938C52.9878 22.271 52.9966 22.1423 53.0421 22.0247C53.0876 21.907 53.1676 21.8059 53.2716 21.7345C53.3757 21.6632 53.4989 21.625 53.625 21.625H56.4375C57.3489 21.624 58.2226 21.2615 58.867 20.617C59.5115 19.9726 59.874 19.0989 59.875 18.1875C59.875 18.082 59.8695 17.9781 59.8602 17.875H53.625C53.4592 17.875 53.3003 17.8092 53.1831 17.6919C53.0658 17.5747 53 17.4158 53 17.25C53 17.0842 53.0658 16.9253 53.1831 16.8081C53.3003 16.6908 53.4592 16.625 53.625 16.625H59.4977C59.2098 16.0609 58.7717 15.5873 58.2317 15.2564C57.6917 14.9256 57.0708 14.7503 56.4375 14.75H53.625C53.4592 14.75 53.3003 14.6842 53.1831 14.5669C53.0658 14.4497 53 14.2908 53 14.125C53 13.9592 53.0658 13.8003 53.1831 13.6831C53.3003 13.5658 53.4592 13.5 53.625 13.5H63.625C63.7908 13.5 63.9497 13.5658 64.0669 13.6831C64.1842 13.8003 64.25 13.9592 64.25 14.125C64.25 14.2908 64.1842 14.4497 64.0669 14.5669C63.9497 14.6842 63.7908 14.75 63.625 14.75H59.6203C60.1778 15.2659 60.6019 15.9093 60.8562 16.625H63.625C63.7908 16.625 63.9497 16.6908 64.0669 16.8081C64.1842 16.9253 64.25 17.0842 64.25 17.25Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_620_13203"
          x1={26.7956}
          y1={41}
          x2={26.7956}
          y2={152.068}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE8ABE" />
          <stop offset={1} stopColor="#8355EC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_620_13203"
          x1={184.985}
          y1={115.611}
          x2={186.919}
          y2={136.599}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1AAF6" />
          <stop offset={1} stopColor="#510DD7" stopOpacity={0.9} />
        </linearGradient>
      </defs>
    </svg>
  );
}
